import { AES, enc } from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET;

export const saveEncrypted = (key, data) => {
  try {
    const jsonString = JSON.stringify(data);
    const encrypted = AES.encrypt(jsonString, SECRET_KEY).toString();
    localStorage.setItem(key, encrypted);
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

export const loadDecrypted = (key) => {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;

    const decrypted = AES.decrypt(encrypted, SECRET_KEY).toString(enc.Utf8);
    return decrypted ? JSON.parse(decrypted) : null;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
